var listPresets = {
    mobile: {
        tag: 'ul',
        marker: '–',
    },
};

export { listPresets };
